import { render } from "./OdIcon.vue?vue&type=template&id=1201207e"
import script from "./OdIcon.vue?vue&type=script&lang=js"
export * from "./OdIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__